import { useState } from "react";
import {
  InvoiceDiscountingInvoice,
  PayableFinancingInvoice,
  useLoanApplication,
  useLoanCalculator,
} from "../../../../contexts";
import { useMedia } from "../../../../hooks";
import AttachedDocumentCard from "./AttachedDocumentCard";
import { MediaPurpose, MediaType } from "../../../../hooks/api/types";
import { UploadInvoiceModal } from "../UploadInvoiceModal";

const InvoiceReviewSection = () => {
  const [invoiceUploading, setInvoiceUploading] = useState<boolean>();
  const [uploadInvoiceModal, setUploadInvoiceModal] = useState<boolean>(false);
  const [invoiceToEdit, setInvoiceToEdit] = useState<
    PayableFinancingInvoice | InvoiceDiscountingInvoice
  >();
  const [newInvoiceFile, setNewInvoiceFile] = useState<File>();
  const { state, actions } = useLoanApplication();
  const { state: calculatorState } = useLoanCalculator();
  const { upload } = useMedia();

  const updateInvoiceInfo = async (
    updatedInvoice: InvoiceDiscountingInvoice | PayableFinancingInvoice,
    file?: File
  ) => {
    if (!file) return;
    setInvoiceUploading(true);

    const newMediaId = await upload({
      file,
      type: MediaType.DOCUMENT,
      purpose: MediaPurpose.INVOICE,
      loanApplicationId: state.id,
    });

    const oldInvoice = { ...updatedInvoice };
    const newInvoice = {
      ...oldInvoice,
      invoiceId: newMediaId,
    };
    try {
      await actions.update({
        id: state.id,
        loanType: calculatorState.type,
        invoices: [newInvoice],
      });
      state.invoices = [newInvoice];
    } catch (err) {
      console.log(err);
    }

    setInvoiceUploading(false);
  };

  return (
    <>
      <div className="cx-bg-white cx-rounded-lg cx-w-full cx-max-w-full cx-shadow-md cx-p-4 sm:cx-p-5 md:cx-p-10 cx-mt-10">
        <div className="cx-flex cx-flex-row cx-items-center cx-justify-between cx-gap-2 cx-w-full cx-min-w-0">
          <div className="cx-min-w-0 cx-flex-1 cx-text-base md:cx-text-xl cx-font-bold cx-leading-snug">
            Invoices
          </div>
        </div>
        <div className="cx-mt-6">
          {!!state.invoices?.filter(Boolean).length && (
            <div className="cx-mt-6">
              <div className="cx-mb-6 cx-mt-4 cx-flex cx-flex-row cx-flex-nowrap cx-gap-4 cx-overflow-x-auto cx-pb-2 cx-min-w-0">
                {state.invoices.filter(Boolean).map((invoice) => (
                  <AttachedDocumentCard
                    document={{ id: invoice.invoiceId }}
                    key={invoice.invoiceId}
                    loading={invoiceUploading}
                    showTitle={false}
                    onChange={async (file) => {
                      if (!file) return;
                      setNewInvoiceFile(file);
                      setInvoiceToEdit(invoice);
                      setUploadInvoiceModal(true);
                    }}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      {uploadInvoiceModal && (
        <UploadInvoiceModal
          isOpen={uploadInvoiceModal}
          onClose={() => {
            setUploadInvoiceModal(false);
          }}
          invoice={invoiceToEdit}
          updateInvoiceInfo={(updatedInvoice) => {
            updateInvoiceInfo(updatedInvoice, newInvoiceFile);
          }}
        />
      )}
    </>
  );
};

export default InvoiceReviewSection;
